import Marquee from 'react-fast-marquee';
import { useLanguage } from '../context/LanguageContext';

const EditorialMarquee = () => {
    const { t } = useLanguage();
    const items = Array(6).fill(t.marquee);
    return (
        <div className="border-y border-white/10 py-6 md:py-8 overflow-hidden" data-testid="editorial-marquee">
            <Marquee speed={35} gradient={false} pauseOnHover>
                {items.map((txt, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-serif italic text-2xl md:text-4xl text-paper/70 tracking-tight whitespace-nowrap px-6">
                            {txt}
                        </span>
                        <span className="inline-block w-2 h-2 bg-dusk rotate-45 mx-6 shrink-0" aria-hidden />
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default EditorialMarquee;
